/* eslint-disable standard/no-callback-literal,camelcase */
/**
 * letsgo
 * @type * {{
 * getInitState: letsgoApi.getInitState,
 * getDataProxy: letsgoApi.getDataProxy,
 * placeOrder: letsgoApi.placeOrder,
 * setState: letsgoApi.setState,
 * setTitle: letsgoApi.setTitle,
 * toast: letsgoApi.toast,
 * log: letsgoApi.log
 * }}
 */

export default {
  getInitState: function (cb) {
    !window.WebViewJavascriptBridge && cb({})
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('getInitState', {}, function (response) {
      if (typeof response === 'string' || response instanceof String) {
        response = JSON.parse(response)
      }
      cb(response.data)
    })
  },
  getDataProxy: function (params, cb) {
    console.log('params ' + JSON.stringify(params))
    console.log(window.WebViewJavascriptBridge)
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('getDataProxy', params, function (response) {
      if (typeof response === 'string' || response instanceof String) {
        response = JSON.parse(response)
      }
      cb(response.data)
    })
  },
  getToken: function (params, cb) {
    console.log('params ' + JSON.stringify(params))
    console.log(window.WebViewJavascriptBridge)
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('getToken', params, function (response) {
      if (typeof response === 'string' || response instanceof String) {
        response = JSON.parse(response)
      }
      cb(response.data.token)
    })
  },
  placeOrder: function (params, cb) {
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('placeOrder', params, function (response) {
      if (typeof response === 'string' || response instanceof String) {
        response = JSON.parse(response)
      }
      cb(response.data)
    })
  },
  publish: function (params) {
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('publish', params, function (response) {
    })
  },
  setNavigation: function (params) {
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('setNavigation', params, function (response) {
    })
  },
  share: function (params) {
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('share', params, function (response) {
    })
  },
  shareImage: function (params) {
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('shareImage', params, function (response) {
    })
  },
  setState: function (params) {
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('setState', params, function (response) {
    })
  },
  setTitle: function (title) {
    document.title = title
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('setTitle', {title: title}, function (response) {
    })
  },
  event: function (params) {
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('event', params, function (response) {
    })
  },
  jumpMiniProgram: function (params) {
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('jumpMiniProgram', params, function (response) {
    })
  },
  toast: function (msg) {
    !window.WebViewJavascriptBridge && alert(msg)
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('toast', {message: msg}, function () {
    })
  },
  log: function (msg) {
    !window.WebViewJavascriptBridge && console.log(msg)
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('log', msg, function () {
    })
  },
  orderPay: function (msg) {
    !window.WebViewJavascriptBridge && console.log(msg)
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('orderPay', msg, function () {
    })
  },
  shareByH5: function (shareInfo) {
    !window.WebViewJavascriptBridge && console.log(shareInfo)
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('shareByH5', shareInfo, function () {
    })
  },
  previewPhotos (urls, index) {
    !window.WebViewJavascriptBridge && console.log(urls, index)
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('previewPhotos', {urls: urls, index: index}, function () {
    })
  },
  jumpUrl: function (httpUrl) {
    !window.WebViewJavascriptBridge && console.log(httpUrl)
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('jumpUrl', {
      jump_url: httpUrl
    }, function () {
    })
  },
  gotoNavigation: function (place, address, lat, lng) {
    !window.WebViewJavascriptBridge && console.log(place, address, lat, lng)
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('gotoNavigation', {
      place, address, lat, lng
    }, function () {

    })
  },
  dialPhoneNumber: function (phoneNumber) {
    !window.WebViewJavascriptBridge && console.log(phoneNumber)
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('dialPhoneNumber', {
      phone_number: phoneNumber
    }, function () {

    })
  },
  savePhoto: function (url) {
    !window.WebViewJavascriptBridge && console.log(url)
    window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('savePhoto', {
      url
    }, function () {

    })
  }
}



// WEBPACK FOOTER //
// ./src/libs/jsapi.js